// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    workforce_my_schedule: 'Leyendo tu cuadrante',
    workforce_my_absences: 'Mirando tus ausencias',
    workforce_request_absence: 'Pidiendo una ausencia',
    workforce_my_balance: 'Contando tus días',
    workforce_find_worker: 'Buscando en la plantilla',
    workforce_worker_schedule: 'Leyendo el cuadrante de alguien',
    workforce_coverage_summary: 'Contando quién está',
    workforce_who_is_available: 'Mirando quién está disponible',
    workforce_pending_absences: 'Mirando las solicitudes en espera',
    workforce_approve_absence: 'Aprobando una solicitud',
    workforce_reject_absence: 'Rechazando una solicitud',
  },
  ca: {
    workforce_my_schedule: 'Llegint el teu quadrant',
    workforce_my_absences: 'Mirant les teves absències',
    workforce_request_absence: 'Demanant una absència',
    workforce_my_balance: 'Comptant els teus dies',
    workforce_find_worker: 'Cercant a la plantilla',
    workforce_worker_schedule: 'Llegint el quadrant d’algú',
    workforce_coverage_summary: 'Comptant qui hi és',
    workforce_who_is_available: 'Mirant qui està disponible',
    workforce_pending_absences: 'Mirant les sol·licituds en espera',
    workforce_approve_absence: 'Aprovant una sol·licitud',
    workforce_reject_absence: 'Rebutjant una sol·licitud',
  },
  en: {
    workforce_my_schedule: 'Reading your rota',
    workforce_my_absences: 'Looking up your time off',
    workforce_request_absence: 'Asking for time off',
    workforce_my_balance: 'Counting your days',
    workforce_find_worker: 'Looking through the staff',
    workforce_worker_schedule: 'Reading somebody’s rota',
    workforce_coverage_summary: 'Counting who is in',
    workforce_who_is_available: 'Seeing who is about',
    workforce_pending_absences: 'Looking at the requests waiting',
    workforce_approve_absence: 'Approving a request',
    workforce_reject_absence: 'Turning a request down',
  },
  fr: {
    workforce_my_schedule: 'Lecture de votre planning',
    workforce_my_absences: 'Consultation de vos absences',
    workforce_request_absence: 'Demande d’absence',
    workforce_my_balance: 'Décompte de vos jours',
    workforce_find_worker: 'Recherche dans le personnel',
    workforce_worker_schedule: 'Lecture du planning de quelqu’un',
    workforce_coverage_summary: 'Qui est présent',
    workforce_who_is_available: 'Qui est disponible',
    workforce_pending_absences: 'Consultation des demandes en attente',
    workforce_approve_absence: 'Approbation d’une demande',
    workforce_reject_absence: 'Refus d’une demande',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
